const STORELINKVER = "3.0.1"

import store from "../../store/store"

export const SCAN_PRINT_MODE = "PRINT"
export const SCAN_NORMAL_MODE = "NORMAL"


function Android () {
  return navigator.userAgent.match(/Android/i)
}

function BlackBerry () {
  return navigator.userAgent.match(/BlackBerry/i)
}

function iOS () {
  return navigator.userAgent.match(/iPhone|iPad|iPod/i)
}

function Opera () {
  return navigator.userAgent.match(/Opera Mini/i)
}

function Windows () {
  return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i)
}


function IE () {

  const ua = window.navigator.userAgent
  const msie = ua.indexOf("MSIE ")

  // If Internet Explorer, return version number
  // eslint-disable-next-line no-useless-escape
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return true
  } else {
    return false
  }
}


export function isIE () {
  return IE()
}

export function isMobile () {
  let _flag = Android() || BlackBerry() || iOS() || Opera() || Windows()
  _flag = _flag === null ? false : _flag

  //Force resize
  if (window.innerWidth < 1024) {
    _flag = true
  }

  return _flag
}


export function getVersion () {
  return STORELINKVER
}


export function isNaN (value) {
  Number.isNaN(Number(value))
}


export function chkLicense (payload) {


  const _currCount = store.state.AppActiveUser.currCount ? store.state.AppActiveUser.currCount : store.state.AppActiveUser.level
  if (
    store.state.AppActiveUser.level <
    _currCount ||
    store.state.AppActiveUser.remain < 0
  ) {

    if (payload) {

      payload.notify({
        title: "라이센스",
        text:
          "라이센스가 만료되었거나 관심제품 수량이 현재 등급에 맞지 않습니다.",
        color: "danger",
        iconPack: "feather",
        icon: "icon-message-square"
      })
    }

    return false
  } else {
    return true
  }
}


export function showError (payload) {
  payload.notify({
    title: "에러",
    text: payload.msg,
    color: "#f44336",
    iconPack: "feather",
    icon: "icon-alert-circle"
  })
}

export function showSuccess (payload) {
  payload.notify({
    color: "#0264fb",
    iconPack: "feather",
    icon: "icon-check",
    title: "메세지",
    text: payload.msg
  })
}

export function getCurrentTime2 (val) {
  let t = ""

  const t1 = new Date(val)

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    `${yyyy
    }/${mm[1] ? mm : `0${mm[0]}`
    }/${dd[1] ? dd : `0${dd[0]}`
    } ${hh
    }:${min
    }:${ss}`

  return t
}

export function formatNumber (value) {
  if (value) {
    value += ""
    const list = value.split(".")
    const prefix = list[0].charAt(0) === "-" ? "-" : ""
    let num = prefix ? list[0].slice(1) : list[0]
    let result = ""
    while (num.length > 3) {
      result = `,${num.slice(-3)}${result}`
      num = num.slice(0, num.length - 3)
    }
    if (num) {
      result = num + result
    }
    return `${prefix}${result}${list[1] ? `.${list[1]}` : ""}`
  }
}

export function getSR (t1) {
  let t = ""

  const yyyy = t1
    .getFullYear()
    .toString()
    .substr(2, 2)
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    `SR-${yyyy
    }${mm[1] ? mm : `0${mm[0]}`
    }${dd[1] ? dd : `0${dd[0]}`
    }.${hh
    }${min
    }${ss}`

  return t
}


export function getLicense () {

  const _level = parseInt(store.state.AppActiveUser.limit)

  if (_level > 300) {
    return 3
  } else if (_level > 100) {
    return 2
  } else if (_level > 5) {
    return 1
  } else {
    return 0
  }
}

export function getCurrentTime (t1) {
  let t = ""


  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    `${yyyy
    }/${mm[1] ? mm : `0${mm[0]}`
    }/${dd[1] ? dd : `0${dd[0]}`
    } ${hh
    }:${min
    }:${ss}`

  return t
}


export function dateDiffInDays (b) {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24
  const a = new Date()
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())

  return Math.floor((utc2 - utc1) / _MS_PER_DAY)
}

export function dateDiffInDaysGap (a, b) {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())

  return Math.floor((utc2 - utc1) / _MS_PER_DAY)
}

export function getCurrentDate (val) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  // const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  // const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  // const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    `${yyyy}/${mm[1] ? mm : `0${mm[0]}`}/${dd[1] ? dd : `0${dd[0]}`}`

  return t
}

export function getCurrentDate2 (val) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  // const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  // const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    `'${yyyy.substr(2)}/${mm[1] ? mm : `0${mm[0]}`}/${dd[1] ? dd : `0${dd[0]}`} ${hh}`

  return t
}


export function getCurrentDate4 (val, postfix) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString().substr(2, 2)
  const mm = (t1.getMonth() + 1).toString()

  t = `${yyyy}년 ${mm[1] ? mm : `0${mm[0]}`}${postfix}`

  return t
}


export function getCurrentDateFormat (val) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()

  t = yyyy + (mm[1] ? mm : `0${mm[0]}`)

  return t
}


export function getHex (str) {
  let result = ""
  for (let i = 0; i < str.length; i++) {
    result += str.charCodeAt(i).toString(16)
  }
  return result
}

export function getCurrentTimeNew () {
  let t = ""

  const t1 = new Date()

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    `${yyyy
    }/${mm[1] ? mm : `0${mm[0]}`
    }/${dd[1] ? dd : `0${dd[0]}`
    } ${hh
    }:${min
    }:${ss}`

  return t
}


export function getCurrentDate3 (val) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  // const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  // const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  // const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    yyyy + (mm[1] ? mm : `0${mm[0]}`) + (dd[1] ? dd : `0${dd[0]}`)

  return t
}

export function getCurrentDate5 (val) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()

  t =
    yyyy + (mm[1] ? mm : `0${mm[0]}`)

  return t
}


export function getCurrentDate3From (val) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  // const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  // const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  // const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    `${yyyy}/${mm[1] ? mm : `0${mm[0]}`}/${dd[1] ? dd : `0${dd[0]}`} 00:00:00`

  return t
}


export function getCurrentDate3To (val) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()
  // const hh = t1.getHours() < 10 ? `0${t1.getHours()}` : t1.getHours()
  // const min = t1.getMinutes() < 10 ? `0${t1.getMinutes()}` : t1.getMinutes()
  // const ss = t1.getSeconds() < 10 ? `0${t1.getSeconds()}` : t1.getSeconds()

  t =
    `${yyyy}/${mm[1] ? mm : `0${mm[0]}`}/${dd[1] ? dd : `0${dd[0]}`} 23:59:59`

  return t
}

export function replaceAll (str, searchStr, replaceStr) {
  return str.split(searchStr).join(replaceStr)
}
export function getCurrentDay (val) {
  let t = ""

  const t1 = val

  const yyyy = t1.getFullYear().toString()
  const mm = (t1.getMonth() + 1).toString()
  const dd = t1.getDate().toString()

  t =
    `${yyyy}.${mm[1] ? mm : `0${mm[0]}`}.${dd[1] ? dd : `0${dd[0]}`}`

  return t
}

export function getFormatDate (val, type = "datetime") {
  let clacDate = val
  if (!clacDate) {
    return ""
  }
  if (val.toDate) {
    clacDate = val.toDate()
  } else if (typeof clacDate === "number") {
    clacDate = new Date(clacDate)
  }
  clacDate.setMonth(clacDate.getMonth() + 1)
  const padLeft = data => {
    if (String(data).length > 1) {
      return `${data}`
    }
    return `0${data}`
  }
  const year = clacDate.getFullYear()
  let month = padLeft(clacDate.getMonth())
  const day = padLeft(clacDate.getDate())
  const hour = padLeft(clacDate.getHours())
  const minute = padLeft(clacDate.getMinutes())
  const second = padLeft(clacDate.getSeconds())

  if (month === "00") {
    month = "01"
  }

  if (type === "date") {
    return `${year}-${month}-${day}`
  }

  // datetime
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}

export function getColumnDisabled ({ readOnly = false, currentUser = { uid: "", role: "" }, disableRule = [], isAdmin = false, isNew = false, targetData = {} }) {
  if (readOnly || !currentUser.uid || !currentUser.role) {
    return true
  }

  if (!disableRule || disableRule.length === 0) {
    return false
  }

  if (disableRule.indexOf("force") > -1) {
    return true
  }
  if (!isNew) {
    if (disableRule.indexOf("all") > -1) {
      return true
    }
    if (disableRule.indexOf("manager") > -1) {
      return currentUser.role === "manager"
    }
    if (disableRule.indexOf("admin") > -1) {
      return currentUser.role === "admin"
    }
    if (disableRule.indexOf("is_md_1") > -1) {
      return (
        !isAdmin &&
        currentUser.uid !== targetData["md_1"]
      )
    }
    if (disableRule.indexOf("is_md_2") > -1) {
      return (
        !isAdmin &&
        currentUser.uid !== targetData["md_2"]
      )
    }
  }
  return false
}